export const isValidEmail = (value: string): Promise<string> => {
  const isEmailCorrect = isValidEmailSync(value)
  const badValidateAnswer = 'Incorrect Email. Format: [aaa]@[aaa].[aaa]'

  return Promise.resolve(isEmailCorrect ? '' : badValidateAnswer)
}

export const isValidEmailSync = (value: string) => {
  // from https://emailregex.com/
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const result = (value || '').match(emailRegex)
  return !!result
}
